import { MatDialogConfig } from '@angular/material/dialog';

export const PERMISSION_DIALOG_CONFIG: MatDialogConfig = {
  width: '500px',
  panelClass: ['firebird-dialog-panel'],
  autoFocus: false,
};
